import { Injectable } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TextConfirmComponent } from '@shared/components/text-confirm/text-confirm.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(private modalService: NzModalService) { }

  confirm(title: string, callback: ((value: any) => void)) {
    return this.modalService.confirm({
      nzTitle: title,
      nzOkText: 'Sim',
      nzOnOk: callback,
      nzCancelText: 'Não'
    });
  }

  confirmWithText(title: string, placeholder: string, callback: ((component: TextConfirmComponent) => void)) {
    this.modalService.create({
      nzTitle: title,
      nzOkText: 'Sim',
      nzOnOk: callback,
      nzCancelText: 'Não',
      nzContent: TextConfirmComponent,
      // nzComponentParams: {
      //   placeholder: placeholder
      // },
      nzClosable: false,

    });
  }

  info(title: string, message: string, callback: ((value: any) => void)) {
    return this.modalService.info({
      nzTitle: title,
      nzContent: message,
      nzOnOk: callback
    });
  }

  info2(title: string, message: string, callback: ((value: any) => void)) {
    return this.modalService.info({
      nzTitle: title,
      nzContent: message,
      nzOnOk: callback,
      nzWidth: 600
    });
  }

  infoVerificacao(title: string, btnOk: string, btnCancel: string, message: string, callback: ((value: any) => void)) {
    return this.modalService.info({
      nzTitle: title,
      nzOkText: btnOk,
      nzOnOk: callback,
      nzCancelText: btnCancel,
      nzContent: message,
      nzWidth: 600
    });
  }
}
